import { render, staticRenderFns } from "./MenusTaobao.vue?vue&type=template&id=08b96366&scoped=true&"
import script from "./MenusTaobao.vue?vue&type=script&lang=js&"
export * from "./MenusTaobao.vue?vue&type=script&lang=js&"
import style0 from "./MenusTaobao.vue?vue&type=style&index=0&id=08b96366&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b96366",
  null
  
)

export default component.exports